import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { LanguageService } from 'src/app/service/language-service/language.service';

@Component({
  selector: 'app-offline-modal',
  templateUrl: './offline-modal.component.html',
  styleUrls: ['./offline-modal.component.scss'],
})
export class OfflineModalComponent  implements OnInit {
  language:string = "es";
  translations;
  @Input() customStyle: string | null = null;
  laguageSub: Subscription;
  hasOfflineChecklistAvailable:boolean = true;
  hasOfflineCoursesAvailable:boolean = true;

  constructor(
    private languageService: LanguageService,
    public router: Router,
    private modalCtrl: ModalController,
  ) { }

  ngOnInit() {
    this.subLanguageConfig();
    const configData = JSON.parse(localStorage.getItem("config_data"));
    this.hasOfflineChecklistAvailable = configData?.has_checklist_offline;
    this.hasOfflineCoursesAvailable = configData?.is_offline;
  }

  goToOfflineCourses() {
    this.closeModal();
    this.router.navigate(["cursos"]);
  }
  goToOfflineChecklist() {
    this.closeModal();
    this.router.navigate(["lista-checklists"]);
  }

  subLanguageConfig() {
    this.laguageSub = this.languageService.getCurrentLang().subscribe(lang => {
      this.language = lang;
      this.languageService.getOfflineTranslate(this.language).subscribe(
      {
        next: (data) => {
         this.translations = data;
        },
        error: (e) => {
          console.log(e);
        }
      }
    );

    });
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  ngOnDestroy() {
    this.laguageSub?.unsubscribe();
	}

}
